import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

Vue.prototype.$globalData = Vue.observable({
  logged: false,
  MsgCount: 0,
  alertColor: "",
  Messages:[],
  alert: "",
  backgroundColor: "",
  IconColor: "",
  snackbar: false,
  links: [],
  subMenu: [],
  overlay: false,
  timeout: -1,
  host: "",
  appName: "",
  url: "",
  currentTime:""
});
Vue.mixin({
  data: function () {
    return {
      LoginUrl: "",
      redirectUrl: "",
      MainDomain: "",

      // LoginUrl: "http://localhost:8080/home",
      // redirectUrl: "https://auth.flattrade.in/?app=novodev",
      // MainDomain: "http://localhost:8080"

      // LoginUrl: "https://novo.flattrade.in/home",
      // redirectUrl: "https://auth.flattrade.in/?app=novo",
      // MainDomain:"https://novo.flattrade.in"
    };
  },
  methods: {
    checkprofileCompleted(clientDetails,profileDetails,userprofile){
if(userprofile){
 return this.handleEmptyString(clientDetails)
}
if(clientDetails == '' || clientDetails == null ||clientDetails == undefined){
  return 'complete your profile to view their details'
}else{
  return this.handleEmptyString(profileDetails)
 }
    },
    handleEmptyString(value) {
      if (value == undefined){
        return 'Not Mentioned'
      }else{

        return value || 'Not Mentioned'; // Replace 'N/A' with any default value you want
      }
    },
    AssignUrl() {
      this.LoginUrl = "http://" + this.$globalData.host + "/home"
      this.redirectUrl = "https://" + this.$globalData.url
      this.MainDomain = "http://" + this.$globalData.host
    },
    MessageBar: function (indicator, Msg) {
      this.$globalData.msg = Msg;
      this.$globalData.alert = true;
      this.$globalData.snackbar = true;
      if (indicator == "S") {
        this.$globalData.backgroundColor = "green lighten-5";
        this.$globalData.IconColor = "green darken-2";
        this.$globalData.Icon = "mdi-check-circle-outline";
        this.$globalData.alerttitle = "Success";
        this.$globalData.timeout = 2000;
      } else if (indicator == "E") {
        this.$globalData.backgroundColor = "error lighten-5";
        this.$globalData.IconColor = "error darken-2";
        this.$globalData.Icon = "mdi-alert";
        this.$globalData.alerttitle = "Error";
        this.$globalData.timeout = 2000;
      }
    },
    LookupArr(Data) {
      if (Data != null && Data != undefined) {

        return Object.keys(Data).map(key => ({
          value: key,
          text: Data[key]
        }));
      } else {
        return []
      }

    },
    getKeyByValue(object, value) {
      if (object != undefined) {
        return Object.keys(object).find(key => object[key] === value);
      } else {
        return ""
      }
    },
    closeAlert() {
      setTimeout(() => {
        this.$globalData.alert = false;
        this.$globalData.snackbar = false;
      }, 3000);
    },
     // to find current time
    //  GetCurrentTime() {
    //   // console.log("Calling time function");
    //   const currentTime = new Date();
    //   let hours = currentTime.getHours();
    //   let minutes = currentTime.getMinutes();
    //   let seconds = currentTime.getSeconds();
    //   hours = (hours < 10 ? "0" : "") + hours;
    //   minutes = (minutes < 10 ? "0" : "") + minutes;
    //   seconds = (seconds < 10 ? "0" : "") + seconds;
    //   //this.currentTime = `08:00:00`;

    //   this.$globalData.currentTime = `${hours}:${minutes}:${seconds}`;
    // },
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
